import * as React from "react";
export const SvgAirFreight = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
		<mask
			id="a"
			width={20}
			height={20}
			x={0}
			y={0}
			maskUnits="userSpaceOnUse"
			style={{
				maskType: "luminance",
			}}
		>
			<path fill="#fff" stroke="#fff" strokeWidth={1.2} d="M18.9 18.9V1.1H1.1v17.8h17.8Z" />
		</mask>
		<g
			stroke={props?.color ?? "#A8A8A8"}
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			strokeWidth={1.2}
			mask="url(#a)"
		>
			<path d="M17.457 17.459a1.484 1.484 0 1 1-2.969 0 1.484 1.484 0 0 1 2.969 0ZM9.293 17.459a1.484 1.484 0 1 1-2.969 0 1.484 1.484 0 0 1 2.969 0Z" />
			<path d="M18.941 13.748H4.84v2.227H18.94v-2.227ZM1.055 1.057h2.3c.82 0 1.485.664 1.485 1.484v11.207M17.457 7.068H7.067v6.68h10.39v-6.68Z" />
			<path d="M15.973 1.873H8.55v5.195h7.422V1.873Z" />
			<path d="M13.375 1.873h-2.227V4.1h2.227V1.873ZM13.746 7.068h-2.969v2.97h2.97v-2.97Z" />
		</g>
	</svg>
);
